export class ValidationUtils {
  static readonly EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  static readonly PHONE_PATTERN = /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/;
  static readonly USERNAME_PATTERN = /^[a-zA-Z0-9_]{3,50}$/;

  static validateEmail(email: string): { valid: boolean; message: string } {
    if (!email) return { valid: false, message: 'L’email est requis' };
    if (!this.EMAIL_PATTERN.test(email)) return { valid: false, message: 'Veuillez entrer une adresse email valide' };
    return { valid: true, message: '' };
  }

  static validateUsername(username: string): { valid: boolean; message: string } {
    if (!username) return { valid: false, message: "Le nom d'utilisateur est requis" };
    if (username.length < 3) return { valid: false, message: "Le nom d'utilisateur doit contenir au moins 3 caractères" };
    if (username.length > 50) return { valid: false, message: "Le nom d'utilisateur ne peut pas dépasser 50 caractères" };
    if (!this.USERNAME_PATTERN.test(username)) return { valid: false, message: "Le nom d'utilisateur ne peut contenir que des lettres, chiffres et underscores" };
    return { valid: true, message: '' };
  }

  static validatePassword(password: string): { valid: boolean; message: string } {
    if (!password) return { valid: false, message: 'Le mot de passe est requis' };
    if (password.length < 6) return { valid: false, message: 'Le mot de passe doit contenir au moins 6 caractères' };
    return { valid: true, message: '' };
  }

  static validatePhone(phone: string): { valid: boolean; message: string } {
    if (!phone) return { valid: false, message: 'Le numéro de téléphone est requis' };
    if (phone.length > 20) return { valid: false, message: 'Le numéro de téléphone ne peut pas dépasser 20 caractères' };
    if (!this.PHONE_PATTERN.test(phone)) return { valid: false, message: 'Veuillez entrer un numéro de téléphone valide' };
    return { valid: true, message: '' };
  }

  static validateName(name: string, field: string): { valid: boolean; message: string } {
    if (!name) return { valid: false, message: `${field} est requis` };
    if (name.length > 100) return { valid: false, message: `${field} ne peut pas dépasser 100 caractères` };
    return { valid: true, message: '' };
  }
}